import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useContent, useSiteText } from "../lib/content";

const ease = [0.16, 1, 0.3, 1];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const WhatWeDo = () => {
  const navigate = useNavigate();
  const { services } = useContent();
  const t = useSiteText();

  return (
    <section
      id="services"
      data-testid="what-we-do-section"
      className="relative bg-[#0a0a0c] pt-20 md:pt-28 pb-12 md:pb-14 px-6 md:px-12 lg:px-16"
    >
      <div className="flex items-end justify-between gap-8">
        <div>
          <span className="text-[11px] uppercase tracking-[0.3em] text-white/85">
            {t("practice_label", "Projection in Practice")}
          </span>
          <div className="mt-2 h-px w-9 bg-[#c8b99d]" />
        </div>
        <button
          onClick={() => scrollTo("capabilities")}
          data-testid="explore-services-link"
          className="group hidden sm:inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-white/50 hover:text-white transition-colors"
        >
          Explore All Services
          <ArrowRight
            size={13}
            className="group-hover:translate-x-1 transition-transform duration-300"
          />
        </button>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
        {services.map((s, i) => (
          <motion.button
            key={s.title}
            type="button"
            onClick={() => navigate(`/services/${s.slug}`)}
            data-testid={`service-card-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.06, ease }}
            className="group flex flex-col text-left border border-white/10 bg-[#0d0d10] hover:border-white/25 transition-colors duration-500"
          >
            <div className="relative h-44 md:h-48 overflow-hidden">
              <img
                src={s.img}
                alt={s.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05]"
              />
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-6">
              <h3 className="font-heading text-sm md:text-[15px] font-medium uppercase tracking-wide text-white leading-snug">
                {s.title}
              </h3>
              <p className="mt-3 flex-1 text-[13px] font-light leading-relaxed text-white/45">
                {s.desc}
              </p>
              <span className="mt-6 inline-flex text-white/40 group-hover:text-[#c8b99d] group-hover:translate-x-1 transition-all duration-300">
                <ArrowRight size={16} strokeWidth={1.25} />
              </span>
            </div>
          </motion.button>
        ))}
      </div>
    </section>
  );
};

export default WhatWeDo;
